import Navbar from "./components/Navbar";
import { Outlet, useLocation } from "react-router-dom";
import Error404 from "./components/Error404";
import Orders from "./apps/Orders/pages/Orders";

// layout Components
export default function Layout() {
  const user = JSON.parse(localStorage.getItem("user"));
  const isAdmin = user.privilege === 1;
  const location = useLocation();
  return (
    <>
      <Navbar />
      {isAdmin ? (
        <Outlet />
      ) : !location.pathname.endsWith("/orders") ? (
        <Error404 />
      ) : (
        <Orders />
      )}
    </>
  );
}
